var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3618 14.2725L26 13.6254L18.3618 12.9783C17.148 12.8694 16.0111 12.3377 15.1494 11.476C14.2877 10.6143 13.756 9.47734 13.6471 8.26359L13 0.625366L12.3529 8.26359C12.244 9.47734 11.7123 10.6143 10.8506 11.476C9.98894 12.3377 8.85197 12.8694 7.63822 12.9783L0 13.6254L7.63822 14.2725C8.85197 14.3813 9.98894 14.913 10.8506 15.7747C11.7123 16.6364 12.244 17.7734 12.3529 18.9871L13 26.6254L13.6471 18.9871C13.756 17.7734 14.2877 16.6364 15.1494 15.7747C16.0111 14.913 17.148 14.3813 18.3618 14.2725Z",
    fill: "#066E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.0254947ef7c8f31a568442cc6bb32483.svg";
export { ForwardRef as ReactComponent };